import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ProfileMatch.module.scss';

interface ProfileMatchProps {
  matchScore?: number | null;
}

const ProfileMatch: FC<ProfileMatchProps> = ({ matchScore }) => {
  const { t } = useTranslation();
  if (!matchScore) {
    return null;
  }

  const percentage = Math.round(matchScore * 100);

  return (
    <div className={styles.wrapper}>
      <span className={styles.text}>
        {t('common.profileMatch', { percentage })}
      </span>
    </div>
  );
};

export default ProfileMatch;
